/* eslint-disable */
import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default {
  state: {
    configurations: {
      screens: [
        {
          name: "splashscreen",
          children: [
            {
              name: "where_to_eat_screen",
              children: [
                {
                  name: "order_screen",
                  children: [
                    {
                      name: "order_recap_screen",
                      children: [
                        {
                          name: "select_payment_screen",
                          children: [
                            {
                              name: "payment_screen",
                              children: [
                                {
                                  name: "post_payment_screen",
                                },
                              ],
                            },
                            {
                              name: "post_payment_screen",
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
                {
                  name: "order_screen",
                  children: [
                    {
                      name: "order_recap_screen",
                      children: [
                        {
                          name: "select_tentcard_number_screen",
                          children: [
                            {
                              name: "select_payment_screen",
                              children: [
                                {
                                  name: "payment_screen",
                                  children: [
                                    {
                                      name: "post_payment_screen",
                                    },
                                  ],
                                },
                                {
                                  name: "post_payment_screen",
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
      configurations: [
        {
          name: "splashscreen",
          isChecked: true,
          config: {
            isSplashButtonBottom: {
              value: false,
              name: "Splash screen button at the bottom",
              description:
                "If true, the button will be at the bottom of the screen, otherwise it will be at the top",
            },
            splash_button: {
              value: ["styles-splash-button"],
              name: "",
              description: "",
            },
            videoOnSplash: {
              value: true,
              name: "Video on splash screen",
              description:
                "If true, the splash screen will have a video, otherwise it will have an image carusel",
            },
          },
        },
        {
          name: "where_to_eat_screen",
          isChecked: true,
          config: {},
        },
        {
          name: "order_screen",
          isChecked: true,
          config: {
            sidebar: {
              value: {
                reverse: false,
                background: "secondary",
                border: "secondary",
                selected: [
                  "styles-primary",
                  "background-tertiary",
                  "text-background",
                ],
                item: [
                  "styles-secondary",
                  "background-secondary",
                  "text-primary",
                ],
              },
              name: "Sidebar",
              description: "The sidebar configuration",
            },
            home: {
              value: false,
              name: "Home",
              description: "If true, the home button will be visible",
            },
            offers: {
              value: false,
              name: "Offers",
              description: "If true, the offers button will be visible",
            },
            "upselling-btn": {
              value: ["styles-ghost"],
              name: "Upselling button",
              description: "upselling button style",
            },
          },
        },
        {
          name: "order_recap_screen",
          isChecked: true,
          config: {
            groupedByCategory: {
              value: true,
              name: "Grouped by category",
              description:
                "If true, the items will be grouped by category, otherwise they will be displayed in a list",
            },
            callToActionTop: {
              value: false,
              name: "Call to action at the top",
              description:
                "If true, the call to action will be at the top of the screen, otherwise it will be at the bottom",
            },
            areSameItemsGrouped: {
              value: true,
              name: "Same items grouped",
              description:
                "If true, the same items will be grouped, otherwise they will be displayed separately",
            },
            badgeForOneElement: {
              value: false,
              name: "Badge for one element",
              description:
                "If true, the badge will be displayed for one element, otherwise it will be displayed for more than one element",
            },
            card: {
              value: {
                badge: [
                  "styles-primary",
                  "background-secondary",
                  "text-primary",
                ],
                "badge-qty": ["background-primary", "text-background"],
                default: ["styles-secondary"],
                modified: ["styles-primary"],
              },
              name: "Badge",
              description: "If true, the badge will be displayed",
            },
            "pay-button": {
              value: [
                "background-secondary",
                "text-primary",
                "border-secondary",
                "font-ultra",
              ],
              name: "Pay button",
              description: "The pay button configuration",
            },
          },
        },
        {
          name: "select_tentcard_number_screen",
          isChecked: true,
          config: {},
        },
        {
          name: "select_payment_screen",
          isChecked: true,
          config: {},
        },
        {
          name: "post_payment_screen",
          isChecked: true,
          config: {},
        },
        {
          name: "payment_screen",
          isChecked: true,
          config: {},
        },
      ],
      globalConfig: {
        negativeQtySelling: {
          value: false,
          name: "Negative quantity selling",
          description:
            "If true, the item can be sold even with a negative or 0 quantity",
        },
        modifyMenu: {
          name: "Modifica menu",
          description: "Modifica il menu dai",
          value: {
            title: ["font-ultra", "text-primary"],
            font: ["font-ultra", "text-primary"],
            "confirm-button": [
              "background-secondary",
              "text-primary",
              "font-bold",
              "border-secondary",
            ],
            "back-button": [
              "background-primary",
              "text-secondary",
              "font-bold",
              "border-primary",
            ],
            "edit-icon": ["text-primary", "background-background"],
          },
        },
        productCard: {
          value: {
            badge: ["background-primary", "text-background", "font-ultra"],
            style: ["styles-secondary"],
          },
          name: "Badge",
          description: "If true, the badge will be displayed",
        },
        upselling: {
          value: true,
          name: "Upselling",
          description: "If true, the upselling will be displayed",
        },
        productPopup: {
          value: {
            header: {
              background: "primary",
              text: "primary",
              font: "ultra",
            },
            category: {
              background: "secondary",
              border: "primary",
              title: {
                text: "primary",
                font: "ultra",
              },
              item: ["background-background", "text-primary", "font-ultra"],
              selectedItem: [
                "background-primary",
                "text-background",
                "font-ultra",
              ],
            },
            backgroundGrid: "secondary",
            sidebar: ["styles-ghost", "background-primary", "text-background"],
            sidebarItem: ["styles-secondary"],
            card: {
              background: "background",
              border: "background",
              active: ["styles-primary", "text-background"],
              disabled: [
                "styles-secondary",
                "text-background",
                "background-secondary",
              ],
              "active-minus": [
                "styles-secondary",
                "text-background",
                "background-secondary",
              ],
            },
            footer: {
              background: "background",
              confirm: [
                "background-secondary",
                "text-primary",
                "font-ultra",
                "border-secondary",
              ],
            },
            background: "background",
            text: "primary",
            font: "ultra",
          },
          name: "Product popup",
          description: "The product popup configuration",
        },
        "where-to-eat-screen-colors": {
          value: {
            icon: "primary",
            text: "primary",
            border: "primary",
          },
          name: "Where to eat screen colors",
          description: "Where to eat screen colors",
        },
        "back-popup-button": {
          value: ["background-secondary", "text-primary", "border-secondary"],
          name: "Back popup button",
          description: "The back popup button configuration",
        },
        "screen-layout": {
          value: {
            header: {
              style: ["background-primary"],
              "back-btn": [
                "styles-secondary",
                "border-background",
                "font-bold",
              ],
              "selected-btn": [
                "border-primary",
                "background-primary",
                "text-background",
                "font-ultra",
              ],
              "order-btn": [
                "styles-secondary",
                "border-background",
                "font-bold",
              ],
              "cancel-btn": [
                "styles-secondary",
                "border-background",
                "font-bold",
              ],
            },
            "small-buttons": {
              "accessibility-btn-on": ["styles-primary", "text-background"],
              "accessibility-btn-off": [
                "background-background",
                "border-primary",
                "text-primary",
                "font-ultra",
              ],
              "language-btn-on": ["styles-primary", "text-background"],
              "language-btn-off": [
                "background-background",
                "border-primary",
                "text-primary",
                "font-ultra",
              ],
            },
            background: "background",
            border: "primary",
          },
          name: "Screen layout",
          description: "The screen layout configuration",
        },
        "stepper-popup": {
          value: {
            title: ["text-primary", "font-ultra"],
            timeline: {
              "text-off": ["text-secondary", "font-ultra"],
              "text-on": ["text-primary", "font-ultra"],
              "background-off": ["background-secondary"],
              "background-on": ["background-primary"],
            },
          },
          name: "Stepper popup",
          description: "Scegli gli stili dai",
        },
        "select-tentcard-number-screen": {
          value: {
            title: ["text-primary", "font-ultra"],
            popup: [
              "background-background",
              "text-primary",
              "font-ultra",
              "border-primary",
            ],
          },
          name: "Select tentcard number screen",
          description: "The select tentcard number screen configuration",
        },
        "keyboard-popup": {
          value: {
            popup: ["background-background", "text-primary", "font-bold"],
            keyboard: ["background-secondary", "text-background", "font-ultra"],
            key: [
              "background-white",
              "text-primary",
              "font-ultra",
              "border-background",
            ],
            "key-active": [
              "background-secondary",
              "text-primary",
              "font-ultra",
              "border-secondary",
            ],
            "keyboard-input": [
              "background-background",
              "border-primary",
              "text-primary",
              "font-ultra",
            ],
            "keyboard-input-active": [
              "background-primary",
              "border-primary",
              "text-background",
              "font-ultra",
            ],
            "enter-btn": [
              "background-primary",
              "text-background",
              "font-ultra",
            ],
          },
          name: "Keyboard popup",
          description: "Descrizione accattivante",
        },
        "continue-without-number-btn": {
          value: [
            "background-foreground",
            "border-foreground",
            "text-background",
            "font-ultra",
          ],
          name: "Continue without number button",
          description: "The continue without number button configuration",
        },
        accessibility: {
          value: {
            font: "light",
            background: "background",
            text: "primary",
            switch: {
              background: "primary",
              text: "secondary",
            },
            "close-button": {
              background: "primary",
              text: "secondary",
            },
          },
          name: "Accessibility",
          description: "The accessibility configuration",
        },
        "language-popup": {
          value: {
            background: "background",
            text: "foreground",
            font: "cursive",
            button: "default-button",
            "active-bg": "primary",
            "active-text": "background",
          },
          name: "Language popup",
          description: "The language popup configuration",
        },
        maxVariantPerCategory: {
          value: 5,
          name: "Max variants per category",
          description: "The maximum number of variants per category",
        },
        maxVariant: {
          value: 3,
          name: "Max variants",
          description: "The maximum number of each variants",
        },
        debug: {
          value: false,
          name: "Debug",
          description: "If true, the app will be in debug mode",
        },
        demo: {
          value: false,
          name: "Debug",
          description: "If true, the app will be in debug mode",
        },
        paymentMethod: {
          value: {
            pos: true,
            checkout: true,
            cash: false,
          },
          name: "Payment method",
          description: "The payment method",
        },
        server: {
          value: {
            prodotti: {
              url: "http://127.0.0.1:3300/api/totem/categorie",
            },
            menu: {
              url: "http://127.0.0.1:3300/api/totem/menu",
            },
            varianti: {
              url: "http://127.0.0.1:3300/api/totem/prodotti/variazioni",
            },
            acquisto: {
              url: "http://127.0.0.1:3300/api/totem/acquisto",
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
            },
            printerStatus: {
              url: "http://127.0.0.1:3300/api/printers/status",
            },
            richiestaPagamento: {
              url: "http://127.0.0.1:3300/api/ingenico/richiestaPagamento",
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: {
                payload: {
                  tml: "136107910",
                  ip: "192.168.50.12",
                  porta: "60000",
                  payment: {
                    amount: 0,
                  },
                },
              },
            },
            getStatoOperazione: {
              url: "http://127.0.0.1:3300/api/ingenico/getStatoOperazione",
            },
            getNumeratore: {
              url:
                "http://127.0.0.1:3300/api/configurations/documenti/numeratore/totem",
              headers: {
                Authorization: ";lskdfjg;lsdkjtpoweiurasdlkfjghns",
              },
            },
          },
          name: "Dark mode",
          description:
            "If true, the app will be in dark mode, otherwise it will be in light mode",
        },
        styles: {
          value: {
            "background-primary": {
              background: "primary",
            },
            "background-secondary": {
              background: "secondary",
            },
            "background-foreground": {
              background: "foreground",
            },
            "background-background": {
              background: "background",
            },
            "background-white": {
              background: "#FFFFFF",
            },
            "text-primary": {
              text: "primary",
            },
            "text-secondary": {
              text: "secondary",
            },
            "text-foreground": {
              text: "foreground",
            },
            "text-background": {
              text: "background",
            },
            "font-bold": {
              font: "bold",
            },
            "font-cursive": {
              font: "cursive",
            },
            "font-light": {
              font: "light",
            },
            "font-ultra": {
              font: "ultra",
            },
            "border-primary": {
              border: "primary",
            },
            "border-secondary": {
              border: "secondary",
            },
            "border-foreground": {
              border: "foreground",
            },
            "border-background": {
              border: "background",
            },
            "styles-ghost": {
              background: "#FFFFFF",
              text: "foreground",
              font: "ultra",
            },
            "styles-primary": {
              background: "primary",
              text: "secondary",
              font: "ultra",
              border: "primary",
            },
            "styles-splash-button": {
              background: "background",
              text: "primary",
              font: "ultra",
              border: "primary",
            },
            "styles-secondary": {
              background: "background",
              text: "primary",
              font: "ultra",
              border: "primary",
            },
            "styles-tertiary": {
              background: "secondary",
              text: "background",
              font: "ultra",
              border: "primary",
            },
            "styles-prprrprp": {
              background: "background",
              text: "primary",
              font: "ultra",
              border: "primary",
            },
          },
          name: "Badge for one element",
          description:
            "If true, the badge will be displayed for one element, otherwise it will be displayed for more than one element",
        },
      },
    },
    theme: {
      breakpoints: [576, 768, 992],
      themes: [
        {
          name: "default",
          title: "Default",
          colors: {
            background: "#ffffff",
            foreground: "#403F4C",
            primary: "#f9db79",
            secondary: "#fff9e3",
          },
          texts: {
            size: {
              tiny: [6, 16, 20, 24],
              small: [8, 18, 24, 28],
              medium: [10, 22, 28, 36],
              large: [12, 28, 36, 42],
              huge: [14, 34, 42, 48],
              title: [16, 48, 56, 64],
              biggest: [30, 60, 72, 84],
            },
          },
          shadows: {
            small: [
              {
                color: "#20000000",
                spread: 1,
                offset: [0, 0],
                radius: 8,
              },
              {
                color: "#20000000",
                spread: 1,
                offset: [0, 0],
                radius: 8,
              },
              {
                color: "#20000000",
                spread: 1,
                offset: [0, 0],
                radius: 8,
              },
              {
                color: "#20000000",
                spread: 1,
                offset: [0, 0],
                radius: 8,
              },
            ],
            medium: [
              {
                color: "#20000000",
                spread: 1,
                offset: [0, 0],
                radius: 8,
              },
              {
                color: "#20000000",
                spread: 1,
                offset: [0, 0],
                radius: 8,
              },
              {
                color: "#20000000",
                spread: 1,
                offset: [0, 0],
                radius: 8,
              },
              {
                color: "#20000000",
                spread: 1,
                offset: [0, 0],
                radius: 8,
              },
            ],
            large: [
              {
                color: "#20000000",
                spread: 1,
                offset: [0, 0],
                radius: 8,
              },
              {
                color: "#20000000",
                spread: 1,
                offset: [0, 0],
                radius: 8,
              },
              {
                color: "#20000000",
                spread: 1,
                offset: [0, 0],
                radius: 8,
              },
              {
                color: "#20000000",
                spread: 1,
                offset: [0, 0],
                radius: 8,
              },
            ],
          },
          border: {
            radius: {
              small: [12, 12, 12, 12],
              medium: [24, 24, 24, 24],
              large: [36, 36, 36, 36],
            },
          },
          padding: {
            small: [4, 6, 8, 12],
            medium: [8, 10, 12, 16],
            large: [12, 14, 16, 24],
          },
        },
        {
          name: "accessibility",
          title: "Accessibilità",
          colors: {
            background: "#FFFFFF",
            foreground: "#1E1F21",
            primary: "#661111",
            secondary: "#FAF4EB",
          },
          texts: {
            size: {
              tiny: [6, 16, 20, 24],
              small: [8, 18, 24, 28],
              medium: [10, 22, 28, 36],
              large: [12, 28, 36, 42],
              huge: [14, 34, 42, 48],
              title: [16, 48, 56, 64],
              biggest: [30, 60, 72, 84],
            },
          },
          shadows: {
            small: [
              {
                color: "#000000",
                spread: 5,
                offset: [0, 0],
                radius: 0,
              },
              {
                color: "#000000",
                spread: 5,
                offset: [0, 0],
                radius: 0,
              },
              {
                color: "#000000",
                spread: 5,
                offset: [0, 0],
                radius: 0,
              },
              {
                color: "#000000",
                spread: 5,
                offset: [0, 0],
                radius: 0,
              },
            ],
            medium: [
              {
                color: "#000000",
                spread: 5,
                offset: [0, 0],
                radius: 0,
              },
              {
                color: "#000000",
                spread: 5,
                offset: [0, 0],
                radius: 0,
              },
              {
                color: "#000000",
                spread: 5,
                offset: [0, 0],
                radius: 0,
              },
              {
                color: "#000000",
                spread: 5,
                offset: [0, 0],
                radius: 0,
              },
            ],
            large: [
              {
                color: "#000000",
                spread: 5,
                offset: [0, 0],
                radius: 0,
              },
              {
                color: "#000000",
                spread: 5,
                offset: [0, 0],
                radius: 0,
              },
              {
                color: "#000000",
                spread: 5,
                offset: [0, 0],
                radius: 0,
              },
              {
                color: "#000000",
                spread: 5,
                offset: [0, 0],
                radius: 0,
              },
            ],
          },
          border: {
            radius: {
              small: [0, 0, 0, 0],
              medium: [0, 0, 0, 0],
              large: [0, 0, 0, 0],
            },
          },
          padding: {
            small: [4, 6, 8, 12],
            medium: [8, 10, 12, 16],
            large: [12, 14, 16, 24],
          },
        },
      ],
    },
    languages: [
      {
        name: "Italiano",
        code: "it",
        isChecked: true,
        text: {
          dialog: {
            cancel: "Annulla",
            confirm: "Conferma",
          },
          splash_screen: {
            call_to_action: "TOCCA PER",
            call_to_action2: "CONTINUARE",
          },
          screen_layout: {
            back: "Indietro",
            cancel: ["Cancella", "Ordine"],
            selected_items: "{} SELEZIONATI",
            order: ["COMPLETA", "L'ORDINE"],
            accessibility: "Accessibilità",
            language: "Lingua",
            add: "AGGIUNGI",
            remove: "TOGLI",
            confirm: "CONFERMA",
          },
          order_screen: {
            order: "Ordina",
            recap: "Riepilogo",
          },
          variant_popup: {
            add: "Aggiungi",
            remove: "Togli",
          },
          order_recap_screen: {
            recap: "Riepilogo ordine",
            products: "HAI PRESO {} PRODOTTI",
            total: "TOTALE ORDINE:",
            pay: "PAGA ORA",
            remove: "RIMUOVI",
          },
          where_to_eat_screen: {
            choose: ["Scegli dove", "vuoi mangiare"],
            takeaway: "DA ASPORTO",
            here: "AL TAVOLO",
          },
          crea_piadina_button: {
            create: ["CREA LA", "TUA PIADINA"],
          },
          select_payment_screen: {
            pay: "DOVE VORRESTI PAGARE?",
            here: "Qui",
            register: "Alla cassa",
          },
          post_payment_screen: {
            thanks: "GRAZIE",
            state: ["Il tuo ordine", "è in elaborazione"],
            confirm: "Vai alla cassa per completare il tuo ordine",
            goodbye: "ARRIVEDERCI",
          },
          order_screen_home: {
            qr_title: ["REGISTRATI", "O ACCEDI"],
            qr_description: "Per ricevere le nostre fantastiche offerte!",
            news_title: "LE ULTIME NOVITÀ",
          },
          order_screen_offers: {
            offers_title: "OFFERTE",
            rewards: ["I TUOI", "PREMI"],
            offers_code: "Digita il codice offerta:",
          },
          back_popup: {
            confirm: "Vuoi rimanere qui?",
            description: "Hai ancora tempo per ordinare",
            button_label: "Si, voglio rimanere",
          },
          crea_piadina_popup: {
            category: "CATEGORIE",
            price: "Prezzo",
            sidebar_header: ["Rimuovi", "Ingredienti"],
            confirm: "CONFERMA",
          },
          toast_popup: {
            add: "Aggiunto",
          },
          accessibility_popup: {
            title: "ACCESSIBILITà",
            contrast: "Contrasto elevato",
            disability: "Disabilità motoria",
            close: "Chiudi",
          },
          select_tent_cart_screen: {
            title: "SCEGLI IL NUMERO DEL TAVOLO",
            continue_without_number: ["Oppure continua", "senza numero"],
          },
          keyboard_popup: {
            enter: "INVIO",
          },
          upselling_popup: {
            title: "Vuoi aggiungere qualcosa al tuo ordine?",
            no_thanks: "No, grazie",
          },
          payment_screen: {
            printer_error: "Errore della stampante",
            pos_error: "Errore del pos",
            total: "Totale: ",
            waiting: "In attesa...",
            payment_error: "Errore nel pagamento",
            follow_instructions: "Segui le istruzioni sul terminale",
            payment_ok: "Pagamento effettuato",
            refresh: "Ricarica",
            or: "Oppure",
            register: "Paga alla cassa",
          },
          modify_menu_dialog: {
            change_product: ["PERSONALIZZA", "PRODOTTO", "CAMBIA"],
            continue: "Prosegui",
            select: "Seleziona un prodotto:",
            cancel: "Annulla",
          },
          delete_item_popup: {
            delete: ["Elimina", "ordine"],
            cancel: "Annulla",
            subtitle: [
              "Vuoi eliminare il tuo ordine?",
              "Vuoi eliminare questo prodotto?",
              "Sei sicuro di voler annullare questo ordine?",
            ],
            confirm: "Sí, voglio eliminare",
            close: "No, annulla",
          },
        },
      },
      {
        name: "English",
        code: "gb",
        isChecked: true,
        text: {
          dialog: {
            cancel: "Cancel",
            confirm: "Confirm",
          },
          splash_screen: {
            call_to_action: "TOUCH TO CONTINUE",
          },
          screen_layout: {
            back: "Back",
            cancel: ["Cancel", "Order"],
            selected_items: "{} SELECTED",
            order: ["COMPLETE", "ORDER"],
            accessibility: "Accessibility",
            language: "Language",
            add: "ADD",
            remove: "REMOVE",
            confirm: "CONFIRM",
          },
          order_screen: {
            order: "Order",
            recap: "Summary",
          },
          variant_popup: {
            add: "Add",
            remove: "Remove",
          },
          order_recap_screen: {
            recap: "ORDER SUMMARY",
            products: "YOU TOOK {} PRODUCTS",
            total: "ORDER TOTAL:",
            pay: "PAY NOW",
            remove: "REMOVE",
          },
          where_to_eat_screen: {
            choose: ["Choose where", "you want to eat"],
            takeaway: "TAKEAWAY",
            here: "AT TABLE",
          },
          crea_piadina_button: {
            create: ["YOUR", "PIADINA"],
          },
          select_payment_screen: {
            pay: "WHERE WOULD YOU LIKE TO PAY?",
            here: "Here",
            register: "At the register",
          },
          post_payment_screen: {
            thanks: "THANK YOU",
            state: ["Your order", "is being processed"],
            confirm: "Go to the register to complete your order",
            goodbye: "GOODBYE",
          },
          order_screen_home: {
            qr_title: ["REGISTER", "OR LOGIN"],
            qr_description: "To receive our amazing offers!",
            news_title: "LATEST NEWS",
          },
          order_screen_offers: {
            offers_title: "OFFERS",
            rewards: ["YOUR", "REWARDS"],
            offers_code: "Enter offer code:",
          },
          back_popup: {
            confirm: "Do you want to stay here?",
            description: "You still have time to order",
            button_label: "Yes",
          },
          crea_piadina_popup: {
            category: "CATEGORY",
            price: "Price",
            sidebar_header: ["Remove", "Ingredients"],
            confirm: "CONFIRM",
          },
          toast_popup: {
            add: "Added",
          },
          accessibility_popup: {
            title: "ACCESSIBILITY",
            contrast: "High contrast",
            disability: "Motor disability",
            close: "Close",
          },
          select_tent_cart_screen: {
            title: "CHOOSE THE TABLE NUMBER",
            continue_without_number: ["Or continue", "without number"],
          },
          keyboard_popup: {
            enter: "ENTER",
          },
          upselling_popup: {
            title: "Would you like to add something to your order?",
            no_thanks: "No, thanks",
          },
          payment_screen: {
            printer_error: "Printer error",
            pos_error: "POS error",
            total: "Total: ",
            waiting: "Waiting...",
            payment_error: "Payment error",
            follow_instructions: "Follow the instructions on the terminal",
            payment_ok: "Payment successful",
            refresh: "Refresh",
            or: "Or",
            register: "Pay at the register",
          },
          modify_menu_dialog: {
            change_product: ["CUSTOMIZE", "PRODUCT", "CHANGE"],
            continue: "Continue",
            select: "Select a product:",
            cancel: "Cancel",
          },
          delete_item_popup: {
            delete: ["Delete", "order"],
            cancel: "Cancel",
            subtitle: [
              "Do you want to delete your order?",
              "Do you want to delete this product?",
              "Are you sure you want to cancel this order?",
            ],
            confirm: "Yes, I want to delete",
            close: "No, cancel",
          },
        },
      },
      {
        name: "Français",
        code: "fr",
        isChecked: true,
        text: {
          dialog: {
            cancel: "Annuler",
            confirm: "Confirmer",
          },
          splash_screen: {
            call_to_action: "TOUCHEZ POUR CONTINUER",
          },
          screen_layout: {
            back: "Retour",
            cancel: ["Annuler", "Commande"],
            selected_items: "{} CHOISIS",
            order: ["COMPLÉTER", "LA COMMANDE"],
            accessibility: "Accessibilité",
            language: "Langue",
            add: "AJOUTER",
            remove: "RETIRER",
            confirm: "CONFIRMER",
          },
          order_screen: {
            order: "Commander",
            recap: "Résumé",
          },
          variant_popup: {
            add: "Ajouter",
            remove: "Retirer",
          },
          order_recap_screen: {
            recap: "RÉCAPITULATIF DE LA COMMANDE",
            products: "VOUS AVEZ PRIS {} PRODUITS",
            total: "TOTAL DE LA COMMANDE :",
            pay: "PAYER À PRÉSENT",
            remove: "RETIRER",
          },
          where_to_eat_screen: {
            choose: ["Choisissez où", "vous voulez manger"],
            takeaway: "À EMPORTER",
            here: "À TABLE",
          },
          crea_piadina_button: {
            create: ["CRÉEZ", "PIADINA"],
          },
          select_payment_screen: {
            pay: "OÙ VOULEZ-VOUS PAYER?",
            here: "Ici",
            register: "À la caisse",
          },
          post_payment_screen: {
            thanks: "MERCI",
            state: ["Votre commande", "est en cours"],
            confirm: "Rendez-vous à la caisse pour finaliser votre commande",
            goodbye: "AU REVOIR",
          },
          order_screen_home: {
            qr_title: ["ADHÉREZ", "OU CONNECTEZ"],
            qr_description: "Pour recevoir nos offres incroyables !",
            news_title: "DERNIÈRES NOUVELLES",
          },
          order_screen_offers: {
            offers_title: "OFFRES",
            rewards: ["VOS", "RÉCOMPENSES"],
            offers_code: "Saisissez le code de l'offre:",
          },
          back_popup: {
            confirm: "Voulez-vous rester ici ?",
            description: "Vous avez encore le temps de commander",
            button_label: "Oui",
          },
          crea_piadina_popup: {
            category: "CATÉGORIE",
            price: "Prix",
            sidebar_header: ["Retirer", "Ingrédients"],
            confirm: "CONFIRMER",
          },
          toast_popup: {
            add: "Ajouté",
          },
          accessibility_popup: {
            title: "ACCESSIBILITÉ",
            contrast: "Contraste élevé",
            disability: "Handicap moteur",
            close: "Fermer",
          },
          select_tent_cart_screen: {
            title: "CHOISISSEZ LE NUMÉRO DE LA TABLE",
            continue_without_number: ["Ou continuez", "sans numéro"],
          },
          keyboard_popup: {
            enter: "ENTRÉE",
          },
          upselling_popup: {
            title: "Voulez-vous ajouter quelque chose à votre commande?",
            no_thanks: "Non, merci",
          },
          payment_screen: {
            printer_error: "Erreur d'imprimante",
            pos_error: "Erreur du terminal de paiement",
            total: "Total : ",
            waiting: "En attente...",
            payment_error: "Erreur de paiement",
            follow_instructions: "Suivez les instructions sur le terminal",
            payment_ok: "Paiement réussi",
            refresh: "Rafraîchir",
            or: "Ou",
            register: "Payer à la caisse",
          },
          modify_menu_dialog: {
            change_product: ["PERSONNALISER", "PRODUIT", "CHANGER"],
            continue: "Continuer",
            select: "Sélectionnez un produit :",
            cancel: "Annuler",
          },
          delete_item_popup: {
            delete: ["Supprimer", "commande"],
            cancel: "Annuler",
            subtitle: [
              "Voulez-vous supprimer votre commande ?",
              "Voulez-vous supprimer ce produit ?",
              "Êtes-vous sûr de vouloir annuler cette commande ?",
            ],
            confirm: "Oui, je veux supprimer",
            close: "Non, annuler",
          },
        },
      },
      {
        name: "Español",
        code: "es",
        isChecked: true,
        text: {
          dialog: {
            cancel: "Cancelar",
            confirm: "Confirmar",
          },
          splash_screen: {
            call_to_action: "TOCA PARA CONTINUAR",
          },
          screen_layout: {
            back: "Atrás",
            cancel: ["Cancelar", "Pedido"],
            selected_items: "{} ELEGIDOS",
            order: ["COMPLETAR", "PEDIDO"],
            accessibility: "Accesibilidad",
            language: "Idioma",
            add: "AÑADIR",
            remove: "QUITAR",
            confirm: "CONFIRMAR",
          },
          order_screen: {
            order: "Ordenar",
            recap: "Resumen",
          },
          variant_popup: {
            add: "Añadir",
            remove: "Quitar",
          },
          order_recap_screen: {
            recap: "RESUMEN DEL PEDIDO",
            products: "HAS TOMADO {} PRODUCTOS",
            total: "TOTAL DEL PEDIDO:",
            pay: "PAGA AHORA",
            remove: "QUITAR",
          },
          where_to_eat_screen: {
            choose: ["Elige dónde", "quieres comer"],
            takeaway: "PARA LLEVAR",
            here: "EN LA MESA",
          },
          crea_piadina_button: {
            create: ["CREA TU", "PIADINA"],
          },
          select_payment_screen: {
            pay: "¿DÓNDE TE GUSTARÍA PAGAR?",
            here: "Aquí",
            register: "En la caja",
          },
          post_payment_screen: {
            thanks: "GRACIAS",
            state: ["Tu pedido", "está en proceso"],
            confirm: "Dirígete a la caja para completar tu pedido",
            goodbye: "ADIÓS",
          },
          order_screen_home: {
            qr_title: ["REGÍSTRATE", "O ACCEDE"],
            qr_description: "¡Para recibir nuestras increíbles ofertas!",
            news_title: "ÚLTIMAS NOTICIAS",
          },
          order_screen_offers: {
            offers_title: "OFERTAS",
            rewards: ["TUS", "RECOMPENSAS"],
            offers_code: "Introduce el código de oferta:",
          },
          back_popup: {
            confirm: "¿Quieres quedarte aquí?",
            description: "Aún tienes tiempo para ordenar",
            button_label: "Sí",
          },
          crea_piadina_popup: {
            category: "CATEGORÍA",
            price: "Precio",
            sidebar_header: ["Eliminar", "Ingredientes"],
            confirm: "CONFIRMAR",
          },
          toast_popup: {
            add: "Añadido",
          },
          accessibility_popup: {
            title: "ACCESIBILIDAD",
            contrast: "Alto contraste",
            disability: "Discapacidad motora",
            close: "Cerrar",
          },
          select_tent_cart_screen: {
            title: "ELIGE EL NÚMERO DE MESA",
            continue_without_number: ["O continúa", "sin número"],
          },
          keyboard_popup: {
            enter: "INTRO",
          },
          upselling_popup: {
            title: "¿Quieres añadir algo a tu pedido?",
            no_thanks: "No, gracias",
          },
          payment_screen: {
            printer_error: "Error de impresora",
            pos_error: "Error en el terminal",
            total: "Total: ",
            waiting: "Esperando...",
            payment_error: "Error en el pago",
            follow_instructions: "Siga las instrucciones en el terminal",
            payment_ok: "Pago realizado",
            refresh: "Actualizar",
            or: "O",
            register: "Pague en caja",
          },
          modify_menu_dialog: {
            change_product: ["PERSONALIZAR", "PRODUCTO", "CAMBIAR"],
            continue: "Continuar",
            select: "Selecciona un producto:",
            cancel: "Cancelar",
          },
          delete_item_popup: {
            delete: ["Eliminar", "pedido"],
            cancel: "Cancelar",
            subtitle: [
              "¿Quieres eliminar tu pedido?",
              "¿Quieres eliminar este producto?",
              "¿Estás seguro de que deseas cancelar este pedido?",
            ],
            confirm: "Sí, quiero eliminar",
            close: "No, cancelar",
          },
        },
      },
      {
        name: "Deutsch",
        code: "de",
        isChecked: true,
        text: {
          dialog: {
            cancel: "Abbrechen",
            confirm: "Bestätigen",
          },
          splash_screen: {
            call_to_action: "TIPPE ZUM WEITERFÜHREN",
          },
          screen_layout: {
            back: "Zurück",
            cancel: ["Stornieren", "Bestellung"],
            selected_items: "{} AUSGEWÄHLT",
            order: ["BESTELLEN", "FERTIG"],
            accessibility: "Zugang",
            language: "Sprache",
            add: "HINZUFÜGEN",
            remove: "ENTFERNEN",
            confirm: "BESTÄTIGEN",
          },
          order_screen: {
            order: "Bestellen",
            recap: "Zusammenfassung",
          },
          variant_popup: {
            add: "Hinzufügen",
            remove: "Entfernen",
          },
          order_recap_screen: {
            recap: "BESTELLÜBERSICHT",
            products: "SIE HABEN {} PRODUKTE GEWÄHLT",
            total: "BESTELLGESAMT:",
            pay: "JETZT BEZAHLEN",
            remove: "ENTFERNEN",
          },
          where_to_eat_screen: {
            choose: ["Wählen Sie", "wo Sie essen möchten"],
            takeaway: "ZUM MITNEHMEN",
            here: "AM TISCH",
          },
          crea_piadina_button: {
            create: ["IHRE", "PIADINA"],
          },
          select_payment_screen: {
            pay: "WO MÖCHTEN SIE BEZAHLEN?",
            here: "Hier",
            register: "An der Kasse",
          },
          post_payment_screen: {
            thanks: "DANKE",
            state: ["Ihre Bestellung", "wird bearbeitet"],
            confirm: "Gehen Sie zur Kasse, um Ihre Bestellung abzuschließen",
            goodbye: "AUF WIEDERSEHEN",
          },
          order_screen_home: {
            qr_title: ["ANMELDEN", ""],
            qr_description: "Um unsere tollen Angebote zu erhalten!",
            news_title: "NEUESTE NACHRICHTEN",
          },
          order_screen_offers: {
            offers_title: "ANGEBOTE",
            rewards: ["IHRE", "PRÄMIEN"],
            offers_code: "Geben Sie den Angebotscode ein:",
          },
          back_popup: {
            confirm: "Möchten Sie hier bleiben?",
            description: "Sie haben noch Zeit zu bestellen",
            button_label: "Ja",
          },
          crea_piadina_popup: {
            category: "KATEGORIE",
            price: "Preis",
            sidebar_header: ["Entfernen", "Zutaten"],
            confirm: "BESTÄTIGEN",
          },
          toast_popup: {
            add: "Hinzufügt",
          },
          accessibility_popup: {
            title: "BARRIEREFREIHEIT",
            contrast: "Hoher Kontrast",
            disability: "Motorische Behinderung",
            close: "Schließen",
          },
          select_tent_cart_screen: {
            title: "WÄHLE DIE TISCHNUMMER",
            continue_without_number: ["Oder fahre fort", "ohne Nummer"],
          },
          keyboard_popup: {
            enter: "EINGABE",
          },
          upselling_popup: {
            title: "Möchten Sie etwas zu Ihrer Bestellung hinzufügen?",
            no_thanks: "Nein, danke",
          },
          payment_screen: {
            printer_error: "Druckerfehler",
            pos_error: "POS-Fehler",
            total: "Gesamt: ",
            waiting: "Warten...",
            payment_error: "Zahlungsfehler",
            follow_instructions: "Folgen Sie den Anweisungen auf dem Terminal",
            payment_ok: "Zahlung erfolgreich",
            refresh: "Aktualisieren",
            or: "Oder",
            register: "An der Kasse bezahlen",
          },
          modify_menu_dialog: {
            change_product: ["ANPASSEN", "PRODUKT", "ÄNDERN"],
            continue: "Fortfahren",
            select: "Wählen Sie ein Produkt:",
            cancel: "Abbrechen",
          },
          delete_item_popup: {
            delete: ["Löschen", "Bestellung"],
            cancel: "Abbrechen",
            subtitle: [
              "Möchten Sie Ihre Bestellung löschen?",
              "Möchten Sie dieses Produkt löschen?",
              "Sind Sie sicher, dass Sie diese Bestellung stornieren möchten?",
            ],
            confirm: "Ja, ich möchte löschen",
            close: "Nein, abbrechen",
          },
        },
      },
    ],
  },
  getters: {
    configurations: (state) => state.configurations,
    theme: (state) => state.theme,
    languages: (state) => state.languages,
  },
  mutations: {
    SET_CONFIGURATION_TOTEM(state, { theme, configurations, languages }) {
      state.theme = theme;
      state.configurations = configurations;
      state.languages = languages;
    },
    SET_CONFIGURATIONS(state, { path, value }) {
      SET(state, "configurations", path, value);
    },
    SET_THEME(state, { path: keys, value }) {
      SET(state, "theme", keys, value);
    },
    SET_LANGUAGES(state, { path: keys, value }) {
      SET(state, "languages", keys, value);
    },
  },
  actions: {},
};

function SET(state, initial, keys, value) {
  if (!keys || typeof value === "undefined") return;
  let head = state[initial];
  let target = head;
  for (let i = 0; i < keys.length - 1; i++) {
    if (!target[keys[i]]) {
      return;
    }
    target = target[keys[i]]; // Traverse to the nested object
  }

  target[keys[keys.length - 1]] = value;
  state[initial] = head;
}
